export const accounting = {
    title: "Paramètres des finances",
    period: "Période affichée par défaut",
    'cc-invoice': {
        title: "Vous recevez une copie de la facture envoyée à votre patient",
        label: "Recevoir une copie des factures envoyées par mail"

    }
}
